import React from "react";
import { Link, NavLink } from "react-router-dom";
import { ShoppingBag, Flame } from "lucide-react";
import { useCart } from "../context/CartContext";

const LOGO = "https://customer-assets.emergentagent.com/job_06b5109e-d3c1-4bd0-9f14-6ae825c1cf11/artifacts/31f6t49v_ChatGPT_Image_Nov_1_2025_05_08_16_PM.png";

export const Navbar = () => {
  const { count, setIsOpen } = useCart();

  const linkClass = ({ isActive }) =>
    `font-display text-2xl tracking-wide transition-colors duration-200 ${
      isActive ? "text-brand" : "text-cream hover:text-brand"
    }`;

  return (
    <header
      data-testid="main-navbar"
      className="sticky top-0 z-40 backdrop-blur-xl bg-ink-900/80 border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-home-logo">
          <img src={LOGO} alt="Blazing Edge BBQ" className="h-12 w-12 object-contain" />
          <div className="hidden sm:block leading-none">
            <div className="font-display text-2xl text-brand">BLAZING EDGE</div>
            <div className="font-display text-sm text-cream tracking-[0.3em]">BBQ</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          <NavLink to="/" end className={linkClass} data-testid="nav-home">Home</NavLink>
          <NavLink to="/shop" className={linkClass} data-testid="nav-shop">Shop</NavLink>
          <NavLink to="/about" className={linkClass} data-testid="nav-about">Our Story</NavLink>
          <NavLink to="/pickup" className={linkClass} data-testid="nav-pickup">Pickup</NavLink>
        </nav>

        <button
          data-testid="nav-cart-btn"
          onClick={() => setIsOpen(true)}
          className="relative flex items-center gap-2 px-4 h-11 border-2 border-ink-600 hover:border-brand hover:text-brand text-cream font-display text-xl tracking-wide transition-all duration-200"
        >
          <ShoppingBag size={18} />
          <span>CART</span>
          {count > 0 && (
            <span
              data-testid="nav-cart-count"
              className="absolute -top-2 -right-2 bg-brand text-ink-900 font-display text-sm h-6 min-w-6 px-1.5 flex items-center justify-center"
            >
              {count}
            </span>
          )}
        </button>
      </div>
    </header>
  );
};
